module.exports = __webpack_public_path__ + "static/andrew-nunemaker.1afe9520.webp";